export default __webpack_public_path__ + "static/95-years-15919abd6b73ff336b3e2f5ecd32086d.jpg";